<template>
  <div class="fotersa">
    <div class="tip-icon">
      <span> 客户服务套餐基本信息: </span>
      <a-button class="btthree" @click="$router.go(-1)">返回上级菜单</a-button>
    </div>
    <a-divider />
    <!--客户基本信息详情表格 -->
    <a-table
      :columns="clientColumns"
      :rowKey="
        (record, index) => {
          return index;
        }
      "
      :data-source="tableData"
      :pagination="false"
      :loading="spinning"
      bordered
      size="small"
      :scroll="{ x: 940 }"
    >
      <span slot="payType" slot-scope="text">
        <span v-if="text == 1"
        ><a-badge color="cyan" /></span>
        <span v-else-if="text == 2"
          ><a-badge color="cyan"
        /></span>
        <span v-else-if="text == 3"
          ><a-badge color="orange"
        /></span>
        {{ text | DictionaryFilter("ORDER_PAY_TYPE") }}
      </span>
      <span slot="orderStatus" slot-scope="text">
        <span v-if="text == 1"
        ><a-badge color="cyan" /></span>
        <span v-else-if="text == 2"
          ><a-badge color="orange"
        /></span>
        <span v-else-if="text == 3"
          ><a-badge color="orange"
        /></span>
        <span v-else-if="text == 5"
          ><a-badge color="red"
        /></span>
        {{ text | DictionaryFilter("ORDER_STATUS") }}
      </span>
      <span slot="orderGoodsType" slot-scope="text">
        {{ text | DictionaryFilter("ORDER_GOODS_TYPE") }}
      </span>
    </a-table>

    <div class="tip-icon" style="margin-top: 30px">
      <span> 客户服务套餐详情: </span>
    </div>
    <a-divider />
    <!--客户服务套餐详情表格 -->
    <a-table
      :columns="comboColumns"
      :rowKey="
        (record, index) => {
          return index;
        }
      "
      :data-source="comboTableData"
      :pagination="false"
      :loading="spinning"
      bordered
      size="small"
    >
      <span slot="expiryDate" slot-scope="text">
        {{ text | DictionaryFilter("GOOD_VALIDITY") }}
      </span>
      <span slot="deadlineDate" slot-scope="text">
        {{ toDate(text) }}
      </span>
    </a-table>
    <div style="margin-top: 30px">
    </div>
  </div>
</template>
<script>
import { qcpdQuery } from "@/api/api.js";
import { DictionaryService } from "@common/services/dictionary.service";
import moment from "moment";
moment.locale("zh-cn");
export default {
  components: {},
  data() {
    return {
      tableData: [], //客户信息表格数据
      comboTableData: [], //套餐详情表格数据
      spinning: false,
      //客户表头
      clientColumns: [
        {
          title: "序号",
          width: 40,
          align: "center",
          dataIndex: "index",
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: "订单编号",
          dataIndex: "orderNo",
          key: "orderNo",
          align: "center",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "orderNo" },
        },
        {
          title: "账户姓名",
          dataIndex: "accountName",
          width: 80,
          key: "accountName",
          align: "center",
          ellipsis: true,
          scopedSlots: { customRender: "accountName" },
        },
        {
          title: "套餐名称",
          dataIndex: "pgName",
          align: "center",
          key: "pgName",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "pgName" },
        },
        {
          title: "套餐类型",
          dataIndex: "orderGoodsType",
          key: "orderGoodsType",
          align: "center",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "orderGoodsType" },
        },
        {
          title: "购买数量",
          dataIndex: "buyNum",
          key: "buyNum",
          align: "center",
          ellipsis: true,
          width: 60,
          scopedSlots: { customRender: "buyNum" },
        },
        {
          title: "订单金额(元)",
          dataIndex: "orderAmount",
          key: "orderAmount",
          align: "center",
          ellipsis: true,
          width: 80,
          scopedSlots: { customRender: "orderAmount" },
        },
        {
          title: "优惠金额(元)",
          dataIndex: "discountAmount",
          key: "discountAmount",
          align: "center",
          ellipsis: true,
          width: 80,
          scopedSlots: { customRender: "discountAmount" },
        },
        {
          title: "订单状态",
          dataIndex: "orderStatus",
          key: "orderStatus",
          align: "center",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "orderStatus" },
        },
        {
          title: "支付方式",
          dataIndex: "payType",
          key: "payType",
          align: "center",
          ellipsis: true,
          width: 80,
          scopedSlots: { customRender: "payType" },
        },
        {
          title: "备注",
          dataIndex: " remark",
          align: "center",
          key: " remark",
          ellipsis: true,
          width: 120,
          scopedSlots: { customRender: " remark" },
        },
      ],
      //套餐表头
      comboColumns: [
        {
          title: "序号",
          width: 35,
          align: "center",
          dataIndex: "index",
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: "权益商品名称",
          align: "center",
          dataIndex: "goodName",
          width: 150,
          key: "goodName",
          ellipsis: true,
          scopedSlots: { customRender: "goodName" },
        },
        {
          title: "商品编号",
          align: "center",
          dataIndex: "goodCode",
          width: 120,
          key: "goodCode",
          ellipsis: true,
          scopedSlots: { customRender: "goodCode" },
        },
        {
          title: "账户编号",
          align: "center",
          dataIndex: "accountNo",
          width: 120,
          key: "accountNo",
          ellipsis: true,
          scopedSlots: { customRender: "accountNo" },
        },
        {
          title: "商品单价(元)",
          align: "center",
          dataIndex: "goodPrice",
          width: 100,
          key: "goodPrice",
          ellipsis: true,
          scopedSlots: { customRender: "goodPrice" },
        },
        {
          title: "有效期",
          align: "center",
          dataIndex: "expiryDate",
          width: 80,
          key: "expiryDate",
          ellipsis: true,
          scopedSlots: { customRender: "expiryDate" },
        },
        {
          title: "截止日期",
          align: "center",
          dataIndex: "deadlineDate",
          width: 120,
          key: "deadlineDate",
          ellipsis: true,
          scopedSlots: { customRender: "deadlineDate" },
        },
      ],

      formLayout: "horizontal",
      orderPayTypes: [],
      orderStatuss: [],
      orderGoodsTypes: [],
      custPgStatus: [], //客户套餐状态
      goodValidity: [], //有效期
    };
  },
  watch: {},
  activated() {
    //查询数据字典
    DictionaryService.getAllNeedDic([
      "ORDER_PAY_TYPE",
      "ORDER_STATUS",
      "ORDER_GOODS_TYPE",
      "GOOD_VALIDITY"
    ]).then((res) => {
      this.orderPayTypes = DictionaryService.getOptions("ORDER_PAY_TYPE"); //支付方式
      this.orderStatuss = DictionaryService.getOptions("ORDER_STATUS"); //订单状态
      this.orderGoodsTypes = DictionaryService.getOptions("ORDER_GOODS_TYPE"); //套餐类型
      this.goodValidity = DictionaryService.getOptions("GOOD_VALIDITY"); //有效期
      //查询列表
      this.searchList();
    });
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
          }
        : {};
    },
    buttonItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            wrapperCol: { span: 6, offset: 18 },
          }
        : {};
    },
  },
  methods: {
    //列表查询
    searchList() {
      if (this.tableData.length != 0) this.tableData = [];
      this.spinning = true;
      let ids = {
        custId: this.$route.query.custId,
        id: this.$route.query.id,
      };
      qcpdQuery(ids).then((res) => {
        this.tableData.push(res.content);
        this.comboTableData = res.content.custPgRels;
        this.spinning = false;
      });
    },
    // 时间戳转化日期
    toDate(date) {
      if (date == null) {
        return "";
      } else {
        let date1 = new Date(date);
        let time = this.formatDate(date1);
        return time;
      }
    },
    formatDate(value) {
      if (value == null) {
        return "";
      } else {
        const date = new Date(value);
        const y = date.getFullYear(); // 年
        let MM = date.getMonth() + 1; // 月
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate(); // 日
        d = d < 10 ? "0" + d : d;
        let h = date.getHours(); // 时
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes(); // 分
        m = m < 10 ? "0" + m : m;
        let s = date.getSeconds(); // 秒
        s = s < 10 ? "0" + s : s;
        return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
      }
    },
  },
};
</script>
<style scord></style>
<style lang="less" scoped="scoped">
/deep/.ant-table-body {
  margin-top: -8px !important;
}
.fotersa {
  width: 100%;
  height: 82vh;
  overflow: auto;

  .btthree {
    width: 120px;
    float: right;
  }
}
/deep/ .ant-table-body {
  margin: 0 !important;
  margin-bottom: 10px !important;
}
/deep/.ant-table-tbody > tr > td {
  padding: 11px 16px;
}

::v-deep .ant-table-small.ant-table-bordered .ant-table-placeholder {
  display: none;
}
</style>
